import React from 'react';
import { type FieldValues, type Path, useController, type UseControllerProps } from 'react-hook-form';

import { TextAreaInputField } from '#/shared/components/FormField';

type TextAreaProps = Omit<
  React.ComponentProps<typeof TextAreaInputField>,
  'ref' | 'disabled' | 'required' | 'value' | 'defaultValue' | 'onChange' | 'onBlur'
>;

type FormControlTextAreaProps<TFieldValues extends FieldValues, TName extends Path<TFieldValues>> = UseControllerProps<
  TFieldValues,
  TName
>;

export function FormControlTextArea<TFieldValues extends FieldValues, TName extends Path<TFieldValues>>({
  name,
  control,
  rules,
  defaultValue,
  disabled,
  ...props
}: FormControlTextAreaProps<TFieldValues, TName> & TextAreaProps) {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
    disabled,
  });
  return <TextAreaInputField {...props} {...field} errorMessage={fieldState.error?.message} />;
}
